<!-- 志扬荣誉 -->
<template>
  <div class="frame">
    <div class="popup" v-show="previewShow">
      <div class="mask" @click="closePreview"></div>
      <img :src="previewUrl" class="preview" />
    </div>
    <img
      src="http://api.zyzxgc.cn/file/static/banner_about.jpg"
      class="banner"
    />
    <div :class="{ wrap: activeTab == 2 }">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <div class="thirdNavs">
          <div
            :class="{ nav: true, active: activeTab == 0 }"
            @click="changeTab(0)"
          >
            志扬荣誉
          </div>
          <div
            :class="{ nav: true, active: activeTab == 1 }"
            @click="changeTab(1)"
          >
            软著证书
          </div>
          <div
            :class="{ nav: true, active: activeTab == 2 }"
            @click="changeTab(2)"
          >
            社会责任
          </div>
        </div>
        <div class="tab" v-show="activeTab == 0">
          <sub-title title="志扬荣誉" en="ZHIYANG HONOR"></sub-title>
          <div class="list">
            <div class="item" v-for="item in list" :key="item.id">
              <img
                :src="URL + item.imgUrl"
                class="post"
                @click="preview(item)"
              />
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="tab" v-show="activeTab == 1">
          <sub-title
            title="软件著作权（软著）证书"
            en="SOFTWARE COPYRIGHT CERTIFICATE"
          ></sub-title>
          <div class="tip">
            志扬咨询在软件开发领域的研发实力和创新水平得到了权威机构的认可，获得了多张软件著作权（软著）证书。
            我司申请软著的项目涉及到了多个方向，不仅在技术上具备了领先水平，更在实际应用中为用户提供了全面的解决方案，大大提高了工作效率和用户体验。我司将继续致力于技术创新和开拓进取，为客户提供更专业的服务。
          </div>
          <div class="list list2">
            <div
              class="item"
              v-for="item in list"
              :key="item.id"
              @click="preview(item)"
            >
              <img :src="URL + item.imgUrl" class="post" />
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="tab tab2" v-show="activeTab == 2">
          <div class="social-box">
            <div id="swiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="item in list" :key="item.id">
                  <img :src="URL + item.imgUrl" class="post" />
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
            <div class="right">
              <sub-title
                title="社会责任"
                en="SOCIAL RESPONSIBILITY"
              ></sub-title>
              <div class="line"></div>
              <div class="detail">{{ list[activeIdx].title }}</div>
            </div>
          </div>
        </div>
        <el-pagination
          v-show="activeTab != 2"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.pageIndex"
          :page-size="queryParams.pageSize"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
import { URL } from "@/util/config";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      URL,
      routerHistory: [], // 当前所在位置
      subNavs: [],
      previewShow: false,
      previewUrl: "",
      activeTab: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 12,
        honorType: 1,
        type: 0,
      },
      list: [],
      total: 0,
      activeIdx: 0, // 社会责任激活下标
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
    const { tab } = this.$route.query;
    console.log(tab);
    if (tab !== undefined) {
      this.activeTab = tab;
      this.queryParams.type = tab;
      if (tab == 0) {
        // 荣誉一次性查12个
        this.queryParams.pageSize = 12;
      } else if (tab == 1) {
        this.queryParams.pageSize = 25;
      } else {
        this.queryParams.pageSize = 10;
      }
    }
    if (tab == 2) {
      this.getAllList();
    } else {
      this.getList();
    }
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    initSwiper() {
      let vm = this;
      new window.Swiper("#swiper", {
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChange() {
            vm.activeIdx = this.activeIndex;
          },
        },
      });
    },
    async getList() {
      let res = await this.$api.getHonorList(this.queryParams);
      this.list = res.data.list;
      this.total = res.data.total;
    },
    // 查询社会责任时的数据
    async getAllList() {
      let res = await this.$api.getCertification(this.queryParams);
      this.list = res.data;
      setTimeout(() => {
        this.initSwiper();
      }, 100);
    },
    handleCurrentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
    // 预览
    preview(item) {
      this.previewUrl = this.URL + item.imgUrl;
      this.previewShow = true;
    },
    closePreview() {
      this.previewShow = false;
    },
    changeTab(idx) {
      this.$router.replace("/about/honor?tab=" + idx);
      if (idx == 0) {
        // 荣誉一次性查12个
        this.queryParams.pageSize = 12;
      } else if (idx == 1) {
        this.queryParams.pageSize = 25;
      } else {
        this.queryParams.pageSize = 10;
      }
      this.activeTab = idx;
      this.queryParams.pageIndex = 1;
      this.queryParams.type = idx;
      if (idx == 2) {
        this.getAllList();
      } else {
        this.getList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popup {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1998;

  .mask {
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.8);
  }
  .preview {
    max-width: 60vw;
    max-height: 80vh;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    height: 100vh;
    margin-bottom: 120px;
    background-image: url("http://api.zyzxgc.cn/file/static/social_bg.png");
    background-size: cover;

    &::before {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 44px auto 120px;

    .thirdNavs {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 45px;

      .nav {
        font-size: 20px;
        color: #9a9a9a;
        line-height: 26px;
        cursor: pointer;

        &:hover {
          color: $theme;
          font-weight: bold;
        }

        & + .nav {
          margin-left: 35px;
        }
      }
      .active {
        color: $theme;
        font-weight: bold;
        position: relative;

        &::after {
          content: "";
          display: block;
          width: 37px;
          height: 3px;
          background-color: $theme;
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    .list {
      display: flex;
      flex-wrap: wrap;
      margin: 30px 0 60px;

      .item {
        width: 280px;
        margin: 0 10px 20px;

        .post {
          width: 100%;
          height: 280px;
          object-fit: contain;
          cursor: zoom-in;
        }
        .title {
          margin-top: 20px;
          font-size: 15px;
          color: #5e5d5d;
          text-align: center;
          white-space: pre-wrap;
        }
      }
    }
    .list2 {
      .item {
        width: 200px;
        margin: 0 20px 20px;

        .post {
          height: 200px;
        }
      }
    }
    .tab2 {
      height: 70vh;
      position: relative;
    }
    .social-box {
      display: flex;
      align-items: flex-start;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    #swiper {
      width: 700px;
      height: 500px;
      position: relative;
      overflow: hidden;

      .post {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .right {
      width: 500px;
      margin-left: 50px;

      .line {
        width: 24px;
        height: 2px;
        background-color: $theme;
        margin-top: 50px;
      }
      .detail {
        font-size: 18px;
        color: #5e5d5d;
        line-height: 36px;
        margin-top: 50px;
        text-indent: 2em;
      }
    }
    .tip {
      font-size: 15px;
      color: #5e5d5d;
      line-height: 30px;
      text-indent: 2em;
      margin-top: 40px;
    }
  }
}

@media (max-width: 750px) {
  .popup .preview {
    max-width: 90vw;
    max-height: 90vh;
  }
  .frame {
    .wrap {
      height: auto;
      margin-bottom: 40px;
      background-image: none;
    }
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;

      .thirdNavs {
        padding: 0 10px;
        margin-bottom: 30px;

        .nav {
          font-size: 16px;

          & + .nav {
            margin-left: 10px;
          }
        }
      }
      .list {
        margin: 20px 0;

        .item {
          width: calc(50% - 20px);

          .post {
            height: 200px;
          }
          .title {
            font-size: 14px;
          }
        }
      }
      .tip {
        margin-top: 20px;
      }
      .list2 {
        .item {
          margin: 0 10px 20px;
        }
      }
      .tab2 {
        height: auto;
      }
      .social-box {
        position: static;
        transform: none;
        flex-direction: column;
      }
      #swiper {
        width: 100%;
        height: 260px;
      }
      .right {
        width: 100%;
        margin-left: 0;
        margin-top: 20px;

        .line {
          margin-top: 20px;
        }
        .detail {
          margin-top: 20px;
          font-size: 14px;
          line-height: 25px;
        }
      }
    }
    .tab {
      padding: 0 10px;
      box-sizing: border-box;
    }
  }
}
</style>
